import React from 'react';

export function KaziAtlasLogo({ size = 52, onLight = false }: { size?: number; onLight?: boolean }) {
    // Scale wordmark proportionally with icon size
    const wordmarkSize = Math.round(size * 0.55);   // 46→25  32→18
    const taglineSize  = Math.max(7, Math.round(size * 0.155)); // 46→7  32→5
    const iconWordGap  = Math.round(size * 0.28);   // 46→13  32→9
    // The approved K fold mark is teal/white and remains legible on both the
    // dark workspace shell and light marketing surfaces.
    const kaziColor = onLight ? '#0B2B26' : '#EAF7F3';
    const taglineColor = onLight ? '#56746C' : '#6E948A';

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: iconWordGap }}>
            {/* K fold mark — the approved primary identity. */}
            <svg width={size} height={size} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" aria-label="KaziAtlas mark">
                <rect x="2" y="2" width="60" height="60" rx="17" fill="#0B7C68" />
                <path d="M11 10h11v44H11zM26 29 43 10h14L38 29H26Zm0 6h12l19 19H43L26 37v-2Z" fill="#FFFFFF" />
                <circle cx="47" cy="14" r="3" fill="#2DE8D0" />
            </svg>

            {/* Wordmark — scales with size prop */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                <div style={{
                    fontFamily: "'Plus Jakarta Sans', 'DM Sans', sans-serif",
                    fontSize: wordmarkSize,
                    fontWeight: 750,
                    lineHeight: 1,
                    letterSpacing: '-0.5px',
                }}>
                    <span style={{ color: kaziColor }}>KaziAtlas</span>
                </div>
                <div style={{
                    height: 1,
                    background: 'linear-gradient(90deg, rgba(245,158,11,0.5), rgba(245,158,11,0.1), transparent)',
                }} />
                <div style={{
                    fontFamily: "'DM Sans', sans-serif",
                    fontSize: taglineSize,
                    fontWeight: 400,
                    letterSpacing: '1.5px',
                    color: taglineColor,
                    textTransform: 'uppercase',
                }}>
                    Projects · Tasks · Clients
                </div>
            </div>
        </div>
    );
}
